// Remembers that this browser closed the survey, so a reload during the gap between the POST and
// Knock acting on it doesn't show the card again.
const CLOSED_KEY_PREFIX = 'npsSurveyClosed:';
const CLOSED_TTL_MS = 10 * 60 * 1000;

const closedKey = (userId: string): string => `${CLOSED_KEY_PREFIX}${userId}`;

export const wasClosedRecently = (userId: string): boolean => {
  if (!userId) {
    return false;
  }
  try {
    const raw = localStorage.getItem(closedKey(userId));
    if (!raw) {
      return false;
    }
    const closedAt = Number(raw);
    if (!Number.isFinite(closedAt) || Date.now() - closedAt > CLOSED_TTL_MS) {
      localStorage.removeItem(closedKey(userId));
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const rememberClosed = (userId: string): void => {
  if (!userId) {
    return;
  }
  try {
    localStorage.setItem(closedKey(userId), String(Date.now()));
  } catch {}
};
